var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hhjcTable"},[_c('ivuTable',{attrs:{"row-class-name":_vm.rowClassName,"columns":_vm.tableType === 'result'? _vm.resultColumns: _vm.duizhenColumns,"data":_vm.data,"show-header":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }